module.exports = __webpack_public_path__ + "e11dfdaa7938ed84258de0f0db866dc6.MP3";